import React from 'react';
import {
  Button, ButtonToolbar, Loader, Message, Modal,
} from 'rsuite';
import { CsvImportResponse } from '../api/apiTypes';
import { downloadData } from '../utils/downloadData';

function getSuccessMessage(response: CsvImportResponse): string {
  const updated = response.updated ?? response.total - response.failed;

  return `Successfully updated ${updated} entities.`;
}

function getErrorMessage(response: CsvImportResponse): string {
  return `Failed to update ${response.failed} entities.`;
}

interface ContentProps {
  response: CsvImportResponse;
  onClose: () => void;
}

function Content({ response, onClose }: ContentProps): JSX.Element {
  const isDownloadReportVisible = !!response.report;

  function handleClose(): void {
    onClose?.();
  }

  function handleDownloadReport(): void {
    if (!response?.report) {
      return;
    }

    downloadData(response.report, 'text/plain', 'result.csv');
  }

  return (
    <>
      <Modal.Header
        closeButton={false}
      >
        Total number of uploaded entities in CSV file
        {' '}
        {response.total}
        .
      </Modal.Header>
      <Modal.Body>
        {response.total > response.failed && (
        <Message
          showIcon
          type="success"
          header={getSuccessMessage(response)}
        />
        )}
        {!!response.failed && (
        <Message
          showIcon
          type="error"
          header={getErrorMessage(response)}
        />
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonToolbar>
          {isDownloadReportVisible && (
          <Button onClick={() => handleDownloadReport()}>
            Download report
          </Button>
          )}
          <Button
            appearance="primary"
            onClick={() => handleClose()}
          >
            Close
          </Button>
        </ButtonToolbar>
      </Modal.Footer>
    </>
  );
}

interface Props {
  isLoading: boolean;
  response?: CsvImportResponse;
  onClose?: () => void;
}

export default function CsvImportResultDialog(
  { isLoading, response, onClose }: Props,
): JSX.Element | null {
  if (!response && !isLoading) {
    return null;
  }

  function handleClose() {
    onClose?.();
  }

  return (
    <Modal
      open
      onClose={() => handleClose()}
    >
      {isLoading && (
      <Modal.Body>
        <Loader />
      </Modal.Body>
      )}
      {response && (
      <Content
        response={response}
        onClose={() => handleClose()}
      />
      )}
    </Modal>
  );
}

CsvImportResultDialog.defaultProps = {
  response: undefined,
  onClose: undefined,
};
